import React, { useState, useEffect, useMemo } from 'react'
import { motion } from "framer-motion"
import TypeAnimation from 'react-type-animation';
import styles from "../../styles/DemoPack.module.css"
import AudioRow, { Song } from './AudioRow';

const title = {
    "welcome": { opacity: 0 },
    "personalized_packs": { opacity: 1 },
    "boring_work": { fontSize: 12 },
    "insights": { backgroundColor: "red" }
}

const audioList = {
    "welcome": { opacity: 0 },
    "personalized_packs": { transition: { staggerChildren: 0.1 } },
    "boring_work": { opacity: 1, transition: { staggerChildren: 0.1 } },
    "insights": {}
}

const audioRow = {
    "welcome": { opacity: 0, y: -10 },
    "personalized_packs": { opacity: 0, y: -10 },
    "boring_work": { opacity: 1, y: 0 },
    "insights": {}
}


const songs: Song[] = [
    { title: "No Dashboard", bpm: 148, keyString: "Am", tags: ["hard", "dark"], fileLink: "No Dashboard [148bpm Am hard dark] @mikha_adr" },
    { title: "Audemars", bpm: 127, keyString: "Cm", tags: ["melodic", "bouncy"], fileLink: "Audemars [127bpm Cm melodic bouncy] @mikha_adr" },
    { title: "Chosen", bpm: 98, keyString: "F", tags: ["rnb", "chill"], fileLink: "Chosen [98bpm F rnb chill] @mikha_adr"}
]

export default function DemoPack({ stage, ...rest }) {
    const [showTitleCursor, setShowTitleCursor] = useState(true)
    useEffect(() => {
        if (stage === "personalized_packs") {
            setTimeout(() => setShowTitleCursor(false), 2200)
        }
    }, [stage])

    let headlineSeq = useMemo(() => stage === "welcome" ? [''] : stage === "personalized_packs" ? [100, 'M', 100, 'Ma', 100, 'Max', 100, 'Maxo'] : ["Maxo"], [stage])

    console.log(stage)
    return (
        <motion.div animate={stage} className={` demo-pack ${!showTitleCursor && 'hide-cursor'} ` + styles.DemoPack}>
            <div className={"text-white justify-center text-3xl flex mb-2"}>a pack for <br />{<TypeAnimation
                cursor
                sequence={headlineSeq}
                wrapper="h2"
                className={"ml-2 inline-block text-indigo-500"}
            />}</div>


            <motion.div variants={audioList}>
                {songs.map((s, i) => <motion.div
                    key={`song-${s.title}`}
                    transition={{ type: 'tween', duration: 0.4 }}
                    variants={audioRow}>
                    <AudioRow downloadIndicator={stage === "insights"} {...s} opacity={ i == 0 ? 100 : i == 1 ? 60 : i == 2 ? 20 : 0} />
                </motion.div>)}

            </motion.div>
        </motion.div>
    )
}
